import { useCallback, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { getRecommendedProducts, getUserJourney } from '../indexApi';
import useCustomerData from '../../LandingPage/Hooks/useCustomerData';
import {
  addInventory,
  catalogueRequest,
  fetchCategoryList,
  searchProducts,
} from '../../Inventory/inventoryApi';
import { APIErrorTrackEvent, moengageTrackEvent } from '../../../Analytics/moengageEventFunction';
import { debounceFunction } from '../../../utils/utils';

import moment from 'moment';

const useProductData = () => {
  const [loading, setLoading] = useState(false);
  const [alertMsg, setAlertMsg] = useState({
    color: null,
    msg: null,
  });

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const [successPopupType, setSuccessPopupType] = useState(null);

  const errorColor = '#f44336';
  const successColor = '#4caf50';

  const [showAlert, setShowAlert] = useState(false);

  const [selectedSellerFilter, setSelectedSellerFilter] = useState('all');

  const [totalProductsCount, setTotalProductsCount] = useState(0);

  const [totalPageCount, setTotalPageCount] = useState(0);

  const [filterCategories, setFilterCategories] = useState([]);

  const [filterBrands, setFilterBrands] = useState([]);

  const [selectedFilterBrands, setSelectedFilterBrands] = useState([]);

  const [selectedFilterCategories, setSelectedFilterCategories] = useState([]);

  const [totalProducts, setTotalProducts] = useState([]);

  const [filteredProducts, setFilteredProducts] = useState([]);

  const [filtersShown, setFiltersShown] = useState(false);

  const [brandFiltersShown, setBrandFiltersShown] = useState(true);

  const [searchVal, setSearchVal] = useState('');

  const [categoryFiltersShown, setCategoryFiltersShown] = useState(true);

  const [pageData, setPageData] = useState({
    pageNo: 0,
    pageSize: 25,
  });

  // Add/Edit product related business logics

  const [showCatalogueModal, setShowCatalogueModal] = useState(false);

  const [addLoading, setAddLoading] = useState(false);

  const [showAddProduct, setShowAddProduct] = useState(false);

  const [showModelDetails, setShowModalDetails] = useState(false);

  const [showAddNewBtn, setShowAddNewBtn] = useState(false);

  const [searchedModelId, setSearchedModelId] = useState();

  const [productArray, setProductArray] = useState([]);

  const [category, setCategory] = useState([]);

  const [errorMsg, setErrorMsg] = useState(null);

  const [addProductObj, setAddProductObj] = useState({
    model: null,
    quantity: null,
    brand: null,
    price: null,
    category: null,
    type: null,
    mrp: null,
    productId: null,
    img_hash_list: [],
    primary_img: 0,
    display_name: null,
  });

  let history = useHistory();
  let location = useLocation();

  const loginData = localStorage.getItem('login_data')
    ? JSON.parse(localStorage.getItem('login_data'))
    : null;

  const getUserJourneyDetails = async (supplierId) => {
    const userJourney = await getUserJourney(supplierId);

    const expiresIn = userJourney?.data?.boostDetails?.is_boosted
      ? userJourney?.data?.boostDetails?.expires_at
      : null;

    const journeyCompleted =
      loginData?.falconBusinessType == 'APOB'
        ? true
        : userJourney?.data?.REGISTRATION_STATUS
        ? userJourney?.data?.REGISTRATION_STATUS?.progress == 100 &&
          userJourney?.data?.INVENTORY_ADDITION_STATUS?.progress == 100 &&
          userJourney?.data?.ORDER_RECIEVED?.progress == 100 &&
          userJourney?.data?.ORDER_ACCEPTED?.progress == 100
        : true;

    let dayDifference = 0;

    if (expiresIn) {
      dayDifference = moment(expiresIn).diff(moment(new Date()), 'days');
    }

    localStorage.setItem(
      'login_data',
      JSON.stringify({
        ...loginData,
        userJourney: userJourney?.data,
        userJourneyCompleted: journeyCompleted ? true : false,
        salesBoostOn:
          loginData?.falconBusinessType == 'APOB'
            ? false
            : userJourney?.data?.boostDetails?.is_boosted && dayDifference > 0
            ? true
            : false,
        salesDays: dayDifference,
      })
    );
    if (!loginData?.userJourneyCompleted && journeyCompleted) {
      history.push('/dashboard');
    }
  };

  const onChangeSellerFilter = (type) => {
    setLoading(true);
    setSearchVal('');
    setSelectedSellerFilter(type);
    onApplyFilter(type, 'seller');
    // if (type == 'fast_selling') {
    //   setFilteredProducts([...totalProducts?.filter((product) => product.ranking <= 5)]);
    // } else if (type == 'top_selling') {
    //   setFilteredProducts([...totalProducts?.filter((product) => product.ranking > 5)]);
    // } else {
    //   setFilteredProducts([...totalProducts]);
    // }
    // setSearchVal('');
    setLoading(false);
  };

  const onApplyFilter = (value, type) => {
    let tempProducts = [...totalProducts];
    if (type == 'search') {
      if (selectedSellerFilter != 'all') {
        if (selectedSellerFilter == 'fast_selling') {
          tempProducts = [...tempProducts?.filter((product) => product.ranking <= 5)];
        } else if (selectedSellerFilter == 'top_selling') {
          tempProducts = [...tempProducts?.filter((product) => product.ranking > 5)];
        }
      }
      tempProducts = tempProducts?.filter(
        (product) =>
          product.model.toLowerCase().includes((value || '').toLowerCase()) ||
          product.title.toLowerCase().includes((value || '').toLowerCase())
      );
    } else if (type == 'seller') {
      // if (searchVal) {
      //   tempProducts = tempProducts?.filter(
      //     (product) =>
      //       product.model.toLowerCase().includes((searchVal || '').toLowerCase()) ||
      //       product.title.toLowerCase().includes((searchVal || '').toLowerCase())
      //   );
      // }
      if (value == 'fast_selling') {
        tempProducts = [...tempProducts?.filter((product) => product.ranking <= 5)];
      } else if (value == 'top_selling') {
        tempProducts = [...tempProducts?.filter((product) => product.ranking > 5)];
      }
    }
    setFilteredProducts(tempProducts);
  };

  const onFetchRecommendedProducts = async (isDiscarded, isPagination) => {
    setLoading(true);
    const payload = {
      pageNo: isPagination ? pageData.pageNo + 1 : 0,
      pageSize: pageData.pageSize,
      ...(selectedFilterBrands.length && !isDiscarded
        ? { brand: selectedFilterBrands.join(',') }
        : {}),
      ...(selectedFilterCategories.length && !isDiscarded
        ? { category: selectedFilterCategories.join(',') }
        : {}),
    };
    const data = await getRecommendedProducts(payload);

    if (data?.data?.status === 'success') {
      setTotalProductsCount(data?.data?.count);
      setTotalPageCount(Math.ceil(data?.data?.count / 25));
      setFilterCategories(data?.data?.filters?.parentCategory || []);
      setFilterBrands(data?.data?.filters?.brands || []);

      const updatedProducts = totalProducts.concat([
        ...(data?.data?.categoryTeamAsnRanking || []),
        ...(data?.data?.systemGeneratedAsnRanking || []),
      ]);
      setTotalProducts(
        isPagination
          ? [...updatedProducts]
          : [
              ...(data?.data?.categoryTeamAsnRanking || []),
              ...(data?.data?.systemGeneratedAsnRanking || []),
            ]
      );
      setPageData({
        ...pageData,
        pageNo: isPagination ? pageData.pageNo + 1 : 0,
      });
      if (selectedSellerFilter != 'all') {
        onApplyFilter(selectedSellerFilter, 'seller');
      } else if (searchVal) {
        onApplyFilter(searchVal, 'search');
      } else {
        setFilteredProducts([
          ...(data?.data?.categoryTeamAsnRanking || []),
          ...(data?.data?.systemGeneratedAsnRanking || []),
        ]);
      }
    }
    setLoading(false);
  };

  const onSelectFilter = (name, type) => {
    if (type === 'brand') {
      if (selectedFilterBrands.includes(name)) {
        setSelectedFilterBrands(selectedFilterBrands.filter((brand) => brand !== name));
      } else {
        setSelectedFilterBrands([...selectedFilterBrands, name]);
      }
    } else if (type === 'category') {
      if (selectedFilterCategories.includes(name)) {
        setSelectedFilterCategories(selectedFilterCategories.filter((cat) => cat !== name));
      } else {
        setSelectedFilterCategories([...selectedFilterCategories, name]);
      }
    }
  };

  const onDiscardFilter = () => {
    setSelectedFilterCategories([]);
    setSelectedFilterBrands([]);
    setFiltersShown(false);
    onFetchRecommendedProducts(true);
  };

  const handlePageChange = (type) => {
    if (type == 'prev') {
      setPageData({
        ...pageData,
        pageNo: pageData.pageNo - 1,
      });
    } else if (type == 'next') {
      setPageData({
        ...pageData,
        pageNo: pageData.pageNo + 1,
      });
    }
    setSelectedSellerFilter('all');
  };

  const handleOnChangeSearch = (val) => {
    setSearchVal(val?.target?.value || '');
    onApplyFilter(val?.target?.value || '', 'search');
    // setFilteredProducts(
    //   totalProducts?.filter(
    //     (product) =>
    //       product.model.toLowerCase().includes((val?.target?.value || '').toLowerCase()) ||
    //       product.title.toLowerCase().includes((val?.target?.value || '').toLowerCase())
    //   )
    // );
  };

  // Add/Edit product related business logics

  const handleInvModal = (hideSearch) => {
    clearRequestModal();
    setShowCatalogueModal(true);
    setShowAddNewBtn(false);
  };

  const getCategoryList = async () => {
    await fetchCategoryList().then((res) => {
      if (res && res.data && res.data.status === 'success') {
        setCategory(Object.keys(res.data.data));
      }
    });
  };

  const clearRequestModal = () => {
    clearSearchResult();
    setShowModalDetails(false);
    setAddProductObj({
      model: null,
      category: null,
      brand: null,
      quantity: null,
      price: null,
      type: null,
      mrp: null,
      productId: null,
      pack_quantity: null,
      img_hash_list: [],
    });
  };

  //function to handel autocomplete model search
  const searchModelIdFnc = async (e) => {
    const nextValue = e?.target?.value;
    setAddProductObj({ ...addProductObj, type: 'exsisting' });
    setShowModalDetails(false);
    setSearchedModelId(e?.target?.value);
    if (e?.target?.value.length > 2) {
      getSearchedValues(nextValue);
      // debounceDropDown(nextValue, getSearchedValues(nextValue));
    } else {
      setProductArray(null);
    }
  };

  //function to fetch autocomplete searched model
  const getSearchedValues = async (nextValue) => {
    setShowModalDetails(false);
    const data = { q: nextValue };
    let response = await searchProducts(data);
    if (response && response.data && response.data.status === 'success') {
      moengageTrackEvent('Add_Product_Search', { searchString: nextValue });
      if (response.data.data.length > 0) {
        setProductArray(response.data.data);
      } else {
        setProductArray(response.data.data);
        setShowAddNewBtn(true);
      }
    }
  };

  //function to handle debounce
  const debounceDropDown = useCallback(
    debounceFunction((nextValue) => getSearchedValues(nextValue), 1000),
    []
  );

  //function to handle catalogue request
  const selectedModelFnc = (item, type, obj, preventFromRecentSearch) => {
    if (type === 'new') {
      setShowModalDetails(true);
      setSearchedModelId('');
      setAddProductObj({
        quantity: null,
        price: null,
        category: null,
        mrp: null,
        brand: null,
        model: '',
        type: 'new',
        productId: null,
        pack_quantity: null,
        img_hash_list: [],
      });
      setProductArray(null);
    } else if (type === 'exsisting') {
      setSearchedModelId(item);
      setAddProductObj({
        quantity: null,
        price: null,
        category: null,
        brand: obj?.brand_name,
        mrp: obj.mrp,
        model: item,
        productId: obj.product_id || obj.productId,
        type: 'exsisting',
        pack_quantity: obj.pack_quantity,
        ...(obj.suggested_price ? { suggested_price: obj.suggested_price } : {}),
        img_hash_list: obj?.img_hash_list || [],
        primary_img: obj?.primary_img || 0,
        display_name: obj?.display_name,
      });
      setShowModalDetails(true);
      if (!preventFromRecentSearch) {
        localStorage.setItem(
          'recentSearchedCatalogueItems',
          JSON.stringify(getFilteredRecentSearchArr(obj))
        );
      }
      setShowAddNewBtn(false);
      setProductArray(null);
    }
  };

  const getFilteredRecentSearchArr = (obj) => {
    const recentSearchedCatalogueItems = localStorage.getItem('recentSearchedCatalogueItems')
      ? JSON.parse(localStorage.getItem('recentSearchedCatalogueItems'))
      : [];

    const filteredArr = [
      ...recentSearchedCatalogueItems.filter((item) => item.product_id !== obj.product_id),
      {
        ...obj,
      },
    ].slice(-5);

    return filteredArr;
  };

  //function to clear autocomplete search result
  const clearSearchResult = () => {
    setSearchedModelId('');
    setProductArray(null);
    setShowModalDetails(false);
  };

  //function to show alerts
  const setAlertFnc = (msg, type, show) => {
    setShowAlert(show);
    setAlertMsg({ msg: msg, color: type });
  };

  //functio to handle add catalogue obj
  const productObj = (e) => {
    if (e.target.name === 'files') {
      setAddProductObj({ ...addProductObj, [e.target.name]: e.target.files[0] });
    } else {
      setAddProductObj({ ...addProductObj, [e.target.name]: e.target.value });
    }
    setErrorMsg(null);
  };

  const closeRequestModal = () => {
    setShowCatalogueModal(false);
    setAddProductObj({
      model: null,
      category: null,
      brand: null,
      quantity: null,
      price: null,
      type: null,
      mrp: null,
      productId: null,
      pack_quantity: null,
      img_hash_list: [],
    });
  };

  const getMinPrice = (price) => Math.floor(parseInt(price) * 0.2);

  //function to update reqObj to add inventory
  const addInv = () => {
    let reqObj = {};

    if (addProductObj.type === 'exsisting') {
      if (!addProductObj.quantity && parseInt(addProductObj.quantity) !== 0) {
        setErrorMsg('Quantity is required.');
        return true;
      } else if (parseInt(addProductObj.quantity) === 0) {
        setErrorMsg(`Enter valid quantity`);
      } else if (!addProductObj.price && parseInt(addProductObj.price) !== 0) {
        setErrorMsg('Price is required.');
      } else if (parseInt(addProductObj.price) === 0) {
        setErrorMsg(`Enter valid price`);
      } else if (
        parseInt(addProductObj.price) <
        Math.min(getMinPrice(addProductObj.mrp), addProductObj.suggested_price)
      ) {
        setErrorMsg(`Listing price should not be less than 20% of the MRP ₹${addProductObj.mrp}`);
      } else if (parseInt(addProductObj.price) > addProductObj.mrp) {
        setErrorMsg(`Listing price should not be greater than MRP ₹${addProductObj.mrp}`);
      } else {
        reqObj.productId = addProductObj.productId;
        reqObj.price = addProductObj.price;
        reqObj.qty = addProductObj.quantity;
        setErrorMsg(null);
        addInventoryFnc(reqObj);
      }
    } else {
      const formData = new FormData();
      formData.append('model', addProductObj.model.toUpperCase());
      formData.append('price', parseInt(addProductObj.price));
      formData.append('quantity', parseInt(addProductObj.quantity));
      formData.append('category', addProductObj.category.toUpperCase());
      formData.append('brand', addProductObj.brand.toUpperCase());
      formData.append('productLink', addProductObj.link);
      formData.append('files', addProductObj.files);
      addCatalogueRequest(formData);
    }
  };

  //function to add/edit inventory
  const addInventoryFnc = async (reqObj, type, editType) => {
    setAddLoading(true);
    let response = await addInventory(reqObj).catch((error) =>
      setAlertFnc(
        error && error.response && error.response.data && error.response.data.msg
          ? error.response.data.msg
          : 'Error while adding inventory. Try after sometime.',
        errorColor,
        true
      )
    );
    setAddLoading(false);
    if (response && response.data && response.data.status === 'success') {
      if (type === 'edit') {
        setAlertFnc(`${reqObj.modelName} edited successfully!`, successColor, true);
        moengageTrackEvent(`Product_${editType}_Edit_published`, {
          productId: reqObj.productId,
          category: reqObj.category,
          price: reqObj.price,
          qty: reqObj.qty,
        });
      } else {
        let data = {
          modelName: '',
          // mrp: null,
          price: null,
          qty: null,
        };
        setShowCatalogueModal(false);
        setAlertFnc('Product added successfully!', successColor, true);
        moengageTrackEvent('Product_Published', { params: JSON.stringify(reqObj) });
      }
      getUserJourneyDetails();
      setShowAddProduct(false);
      setShowSuccessPopup(true);
      setSuccessPopupType('product');
    } else {
      let error =
        response && response.data && response.data.errors && response.data.errors[0]
          ? response.data.errors[0]
          : response && response.data && response.data.msg;
      setAlertFnc(
        error ? error : 'Error while adding inventory. Try after sometime.',
        errorColor,
        true
      );
      APIErrorTrackEvent({
        api: response?.data?.config?.url,
        apiPayLoad: JSON.stringify(reqObj),
        errorMsg: error,
      });
    }
  };

  const addCatalogueRequest = async (obj) => {
    try {
      const res = await catalogueRequest(obj);

      if (res && res.data && res.data.status === 'success') {
        let modalConfig = {
          showCancel: true,
          confirmBtnText: 'Please Proceed',
          // cancelBtnText: 'CANCEL',
          onConfirm: closeRequestModal,
          onCancel: closeRequestModal,
          show: false,
          msg: `A new catalogue will be created in next 24 hrs`,
        };

        let moeParams = {
          model: obj.get('model'),
          brand: obj.get('brand'),
          price: obj.get('price'),
          category: obj.get('category'),
        };

        moengageTrackEvent('Product_New Request_Raised', moeParams);
        setAlertFnc('A new catalogue will be created in next 24 hrs', successColor, true);
        getUserJourneyDetails();
      } else {
        let error = res?.data?.errors?.[0] ?? res?.data?.msg ?? 'Something went wrong';
        setAlertFnc(error, errorColor, true);

        APIErrorTrackEvent({
          api: res?.data?.config?.url,
          apiPayLoad: JSON.stringify(obj),
          errorMsg: error,
        });
      }
    } catch (err) {
      setAlertFnc('Network error, please try again.', errorColor, true);
      APIErrorTrackEvent({
        api: 'catalogueRequest',
        apiPayLoad: JSON.stringify(obj),
        errorMsg: err.message,
      });
    } finally {
      setShowCatalogueModal(false);
    }
  };

  return {
    selectedSellerFilter,
    onChangeSellerFilter,
    loading,
    onFetchRecommendedProducts,
    setPageData,
    totalProductsCount,
    pageData,
    filterCategories,
    filterBrands,
    totalProducts,
    onSelectFilter,
    selectedFilterBrands,
    selectedFilterCategories,
    filtersShown,
    setFiltersShown,
    brandFiltersShown,
    setBrandFiltersShown,
    categoryFiltersShown,
    setCategoryFiltersShown,
    onDiscardFilter,
    filteredProducts,
    handlePageChange,
    totalPageCount,
    searchVal,
    handleOnChangeSearch,
    searchModelIdFnc,
    searchedModelId,
    productArray,
    selectedModelFnc,
    clearSearchResult,
    addProductObj,
    productObj,
    showModelDetails,
    showAddNewBtn,
    showCatalogueModal,
    setShowCatalogueModal,
    addInv,
    category,
    handleInvModal,
    getCategoryList,
    showAlert,
    setShowAlert,
    alertMsg,
    getUserJourneyDetails,
    showSuccessPopup,
    setShowSuccessPopup,
    successPopupType,
    setSuccessPopupType,
    showAddProduct,
    setShowAddProduct,
    addLoading,
    errorMsg,
    setErrorMsg,
  };
};

export default useProductData;
